/* Squishyland theme — interactions */
(function () {
  'use strict';

  var theme = window.theme || {};
  var routes = theme.routes || {};

  /* ---------- Helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var format = theme.moneyFormat || '${{amount}}';
    cents = parseInt(cents, 10) || 0;
    function withDelims(n, decimals, thousands, decimal) {
      var fixed = (n / 100).toFixed(decimals);
      var parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimals ? decimal : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelims(cents, 2, "'", '.');
        default: return withDelims(cents, 2, ',', '.');
      }
    });
  }

  /* ---------- Sticky header shadow ---------- */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Announcement rotation ---------- */
  $$('[data-announcement]').forEach(function (bar) {
    var items = $$('.announcement__item', bar);
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4000);
  });

  /* ---------- Mobile nav ---------- */
  var mobileNav = $('[data-mobile-nav]');
  if (mobileNav) {
    mobileNav.addEventListener('toggle', function () { document.body.classList.toggle('is-locked', mobileNav.open); });
    $$('[data-close-mobile-nav]', mobileNav).forEach(function (btn) {
      btn.addEventListener('click', function () { mobileNav.open = false; });
    });
    mobileNav.addEventListener('click', function (e) { if (e.target === mobileNav) mobileNav.open = false; });
  }

  /* ---------- Mobile search toggle ---------- */
  var searchToggle = $('[data-search-toggle]');
  if (searchToggle && header) {
    searchToggle.addEventListener('click', function () {
      var open = header.classList.toggle('is-search-open');
      if (open) { var inp = $('[data-predictive-input]', header); if (inp) inp.focus(); }
    });
  }

  /* ---------- Predictive search ---------- */
  $$('[data-predictive]').forEach(function (wrap) {
    var input = $('[data-predictive-input]', wrap);
    var results = $('[data-predictive-results]', wrap);
    var base = wrap.getAttribute('data-section-url');
    if (!input || !results || !base) return;
    var timer, controller;

    function close() { results.hidden = true; input.setAttribute('aria-expanded', 'false'); }
    function search() {
      var q = input.value.trim();
      if (q.length < 2) { close(); return; }
      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;
      var url = base + '?q=' + encodeURIComponent(q) +
        '&section_id=predictive-search&resources[type]=product,collection,query&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,tag';
      fetch(url, controller ? { signal: controller.signal } : {})
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var content = $('[data-predictive-content]', doc);
          results.innerHTML = content ? content.innerHTML : '';
          results.hidden = !results.innerHTML.trim();
          input.setAttribute('aria-expanded', results.hidden ? 'false' : 'true');
        })
        .catch(function () {});
    }
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(search, 250); });
    input.addEventListener('focus', function () { if (results.innerHTML.trim() && input.value.trim().length > 1) results.hidden = false; });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target) && !e.target.closest('[data-search-toggle]')) close(); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); input.blur(); } });
  });

  /* ---------- Card video preview ---------- */
  $$('.card--has-video').forEach(function (card) {
    var video = $('.card__video video, video.card__video', card) || $('video', card);
    if (!video) return;
    var play = function () {
      var p = video.play();
      if (p && p.then) p.then(function () { card.classList.add('is-playing'); }).catch(function () {});
      else card.classList.add('is-playing');
    };
    var stop = function () { video.pause(); card.classList.remove('is-playing'); };
    card.addEventListener('mouseenter', play);
    card.addEventListener('mouseleave', stop);
    card.addEventListener('focusin', play);
    card.addEventListener('focusout', stop);
  });

  /* ---------- Cart drawer ---------- */
  var drawer = null;
  function getDrawer() { drawer = $('[data-cart-drawer]'); return drawer; }

  function openDrawer() {
    if (!getDrawer()) { window.location.href = routes.cart; return; }
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    var panel = $('.drawer__panel', drawer);
    if (panel) panel.focus();
  }
  function closeDrawer() {
    if (!getDrawer()) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-locked');
  }

  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
      el.classList.remove('bump');
      void el.offsetWidth;
      el.classList.add('bump');
    });
  }

  function refreshCart(sectionsHtml) {
    var tasks = [];
    if (sectionsHtml && sectionsHtml['cart-drawer']) {
      replaceDrawer(sectionsHtml['cart-drawer']);
    } else if (getDrawer()) {
      tasks.push(fetch(routes.root + '?sections=cart-drawer').then(function (r) { return r.json(); }).then(function (data) {
        replaceDrawer(data['cart-drawer']);
      }));
    }
    tasks.push(fetch(routes.cart + '.js').then(function (r) { return r.json(); }).then(function (cart) { updateCount(cart.item_count); }));
    return Promise.all(tasks);
  }

  function replaceDrawer(html) {
    if (!html || !getDrawer()) return;
    var wasOpen = drawer.classList.contains('is-open');
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = $('[data-cart-drawer]', doc);
    if (!fresh) return;
    drawer.innerHTML = fresh.innerHTML;
    if (wasOpen) drawer.classList.add('is-open');
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-cart-toggle]');
    if (toggle && theme.cartType === 'drawer' && getDrawer()) {
      e.preventDefault();
      openDrawer();
      return;
    }
    if (e.target.closest('[data-close-drawer]')) {
      closeDrawer();
      return;
    }
    var qtyBtn = e.target.closest('[data-cart-qty]');
    if (qtyBtn) {
      e.preventDefault();
      changeLine(qtyBtn.getAttribute('data-cart-qty'), qtyBtn.getAttribute('data-qty-value'), qtyBtn);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeDrawer();
    if (mobileNav) mobileNav.open = false;
    var facets = $('[data-facets]');
    if (facets && window.innerWidth < 990) facets.open = false;
  });

  function changeLine(line, quantity, el) {
    var container = el.closest('.drawer__panel, [data-cart-page]') || document.body;
    container.classList.add('is-updating');
    var onCartPage = !!el.closest('[data-cart-page]');
    fetch(routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(quantity, 10), sections: 'cart-drawer' })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (onCartPage) { window.location.reload(); return; }
        updateCount(cart.item_count);
        replaceDrawer(cart.sections && cart.sections['cart-drawer']);
      })
      .catch(function () { window.location.reload(); })
      .finally(function () { container.classList.remove('is-updating'); });
  }

  /* ---------- AJAX add to cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form || theme.cartType !== 'drawer' || !getDrawer()) return;
    e.preventDefault();

    var button = $('[type="submit"]', form);
    var errorEl = $('[data-form-error]', form);
    if (button) { button.classList.add('is-loading'); button.setAttribute('aria-busy', 'true'); }
    if (errorEl) errorEl.hidden = true;

    var body = new FormData(form);
    body.append('sections', 'cart-drawer');
    body.append('sections_url', window.location.pathname);

    fetch(routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: body })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) {
          var msg = res.data.description || res.data.message || 'Something went wrong. Please try again.';
          if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; } else { alert(msg); }
          return;
        }
        if (button && button.classList.contains('card__add')) {
          button.classList.add('is-added');
          setTimeout(function () { button.classList.remove('is-added'); }, 1200);
        }
        return refreshCart(res.data.sections).then(openDrawer);
      })
      .catch(function () { form.submit(); })
      .finally(function () {
        if (button) { button.classList.remove('is-loading'); button.removeAttribute('aria-busy'); }
      });
  });

  /* ---------- Product page ---------- */
  $$('[data-product-section]').forEach(function (section) {
    var jsonEl = $('[data-product-json]', section);
    var data = jsonEl ? JSON.parse(jsonEl.textContent) : { variants: [] };
    var form = $('[data-product-form]', section);
    var idInput = $('[data-variant-id]', section);
    var stage = $('[data-stage]', section);
    var counter = $('[data-counter]', section);
    var mobile = window.matchMedia('(max-width: 989px)');
    var slides = $$('.product__slide', section);

    // Gallery: fade on desktop, swipe (scroll-snap) on mobile
    function markActive(id) {
      slides.forEach(function (s, i) {
        var on = s.getAttribute('data-media-id') === String(id);
        s.classList.toggle('is-active', on);
        if (on && counter) counter.textContent = i + 1;
        var v = $('video', s);
        if (v && !on) v.pause();
      });
      $$('[data-thumb]', section).forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb') === String(id)); });
    }
    function showMedia(id) {
      if (!id) return;
      var target = $('.product__slide[data-media-id="' + id + '"]', section);
      if (!target) return;
      markActive(id);
      if (mobile.matches && stage) stage.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
    }
    $$('[data-thumb]', section).forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.getAttribute('data-thumb')); });
    });
    if (stage && slides.length > 1) {
      var scrollTimer;
      stage.addEventListener('scroll', function () {
        if (!mobile.matches) return;
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var i = Math.round(stage.scrollLeft / stage.clientWidth);
          var s = slides[Math.max(0, Math.min(slides.length - 1, i))];
          if (s) markActive(s.getAttribute('data-media-id'));
        }, 80);
      }, { passive: true });
    }

    // Quantity
    $$('[data-qty]', section).forEach(function (wrap) {
      var input = $('input', wrap);
      $('[data-qty-minus]', wrap).addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
      $('[data-qty-plus]', wrap).addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
    });

    // Share
    $$('[data-share]', section).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = btn.getAttribute('data-url'); var title = btn.getAttribute('data-title');
        var label = $('[data-share-label]', btn);
        if (navigator.share) { navigator.share({ title: title, url: url }).catch(function () {}); return; }
        if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function () {
            if (!label) return;
            var old = label.textContent; label.textContent = 'Link copied! 💕';
            setTimeout(function () { label.textContent = old; }, 1800);
          });
        }
      });
    });

    // Sticky add to cart (mobile)
    var sticky = document.querySelector('[data-sticky-atc]');
    var mainAdd = form ? $('[data-add-button]', form) : null;
    if (sticky && mainAdd && 'IntersectionObserver' in window) {
      var stickyBtn = $('[data-sticky-add]', sticky);
      new IntersectionObserver(function (entries) {
        var show = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
      }).observe(mainAdd);
      if (stickyBtn) stickyBtn.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(mainAdd); else mainAdd.click();
      });
    }

    function updateStock(variant) {
      var note = $('[data-stock-note]', section);
      if (!note) return;
      var q = data.lowStock ? data.lowStock[variant.id] : 0;
      note.hidden = !(q > 0 && variant.available);
      var t = $('[data-stock-text]', note);
      if (t && q > 0) t.textContent = 'Only ' + q + ' left — grab it soon!';
    }

    // Variants
    if (!form || !idInput) return;
    var radios = $$('input[data-option-index]', form);
    if (!radios.length) return;

    function selectedOptions() {
      var opts = [];
      radios.forEach(function (r) { if (r.checked) opts[parseInt(r.getAttribute('data-option-index'), 10)] = r.value; });
      return opts;
    }

    function markAvailability(opts) {
      radios.forEach(function (r) {
        var idx = parseInt(r.getAttribute('data-option-index'), 10);
        var ok = data.variants.some(function (v) {
          if (!v.available || v.options[idx] !== r.value) return false;
          return v.options.every(function (o, i) { return i === idx || i > idx || o === opts[i]; });
        });
        r.parentElement.classList.toggle('is-unavailable', !ok);
      });
    }

    function onChange() {
      var opts = selectedOptions();
      opts.forEach(function (val, i) {
        var label = $('[data-option-value="' + i + '"]', form);
        if (label) label.textContent = val;
      });
      var variant = data.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
      var addLabel = $('[data-add-label]', form);
      var stickyBtn = sticky ? $('[data-sticky-add]', sticky) : null;
      var stickyPrice = sticky ? $('[data-sticky-price]', sticky) : null;
      markAvailability(opts);

      if (!variant) {
        mainAdd.disabled = true;
        addLabel.textContent = 'Unavailable';
        if (stickyBtn) stickyBtn.disabled = true;
        return;
      }
      idInput.value = variant.id;
      mainAdd.disabled = !variant.available;
      addLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
      if (stickyBtn) { stickyBtn.disabled = !variant.available; stickyBtn.textContent = variant.available ? 'Add to cart' : 'Sold out'; }
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

      var priceEl = $('[data-price]', section);
      var compareEl = $('[data-compare-price]', section);
      var badgeEl = $('[data-sale-badge]', section);
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (compareEl) { compareEl.hidden = !onSale; compareEl.textContent = onSale ? formatMoney(variant.compare_at_price) : ''; }
      if (badgeEl) { badgeEl.hidden = !onSale; badgeEl.textContent = onSale ? '-' + Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '%' : ''; }

      updateStock(variant);
      if (variant.featured_media) showMedia(variant.featured_media.id);

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    radios.forEach(function (r) { r.addEventListener('change', onChange); });
    markAvailability(selectedOptions());
  });

  /* ---------- Product recommendations ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url || el.children.length) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = $('[data-recommendations]', doc);
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    }).catch(function () {});
  });

  /* ---------- Footer accordions (mobile only) ---------- */
  var footerAcc = $$('[data-footer-acc]');
  if (footerAcc.length) {
    var ftMq = window.matchMedia('(min-width: 641px)');
    var syncFooter = function () { footerAcc.forEach(function (d) { d.open = ftMq.matches; }); };
    syncFooter();
    if (ftMq.addEventListener) ftMq.addEventListener('change', syncFooter);
    footerAcc.forEach(function (d) {
      var sum = $('summary', d);
      if (sum) sum.addEventListener('click', function (e) { if (ftMq.matches) e.preventDefault(); });
    });
  }

  /* ---------- Collection filters ---------- */
  var facetsForm = $('[data-facets-form]');
  if (facetsForm) {
    var facets = $('[data-facets]', facetsForm);
    var mq = window.matchMedia('(min-width: 990px)');
    var syncFacets = function () { if (facets) facets.open = mq.matches; };
    syncFacets();
    if (mq.addEventListener) mq.addEventListener('change', syncFacets);

    if (facets) {
      facets.addEventListener('toggle', function () {
        if (!mq.matches) document.body.classList.toggle('is-locked', facets.open);
      });
      var closeBtn = $('[data-close-facets]', facets);
      if (closeBtn) closeBtn.addEventListener('click', function () { facets.open = false; });
      // Prevent closing the sidebar on desktop
      var summary = $('summary.facets__toggle', facets);
      if (summary) summary.addEventListener('click', function (e) { if (mq.matches) e.preventDefault(); });
    }

    var submitTimer;
    var submitFacets = function () {
      // Drop empty fields so URLs stay clean
      $$('input, select', facetsForm).forEach(function (f) { f.disabled = f.value === '' && f.name !== 'sort_by'; });
      facetsForm.submit();
    };
    facetsForm.addEventListener('change', function (e) {
      if (!mq.matches && e.target.type === 'checkbox') return; // mobile: wait for "Show results"
      clearTimeout(submitTimer);
      submitTimer = setTimeout(submitFacets, e.target.type === 'number' ? 600 : 50);
    });
    facetsForm.addEventListener('submit', function (e) {
      e.preventDefault();
      submitFacets();
    });
  }
})();
